"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _Badge = _interopRequireDefault(require("@material-ui/core/Badge"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["items", "activeItem", "variant", "tabProps"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Badge = (0, _styles.withStyles)(function () {
  return {
    badge: {
      top: 11,
      right: -15,
      fontSize: 8,
      padding: 0
    }
  };
})(_Badge["default"]);
var Label = function Label(_ref) {
  var name = _ref.name,
    badge = _ref.badge;
  return badge ? /*#__PURE__*/_react["default"].createElement(Badge, {
    badgeContent: badge,
    color: "secondary"
  }, name) : name;
};
Label.propTypes = {
  name: _propTypes["default"].string.isRequired,
  badge: _propTypes["default"].number
};
Label.defaultProps = {
  badge: 0
};
var FilterTabs = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      borderBottom: "1px solid ".concat(theme.palette.lightGrey.dark)
    },
    indicator: {
      height: 4,
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      '& > div': {
        maxWidth: 92,
        width: '100%',
        backgroundColor: theme.palette.primary.light
      }
    }
  };
})(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_Tabs["default"], _extends({}, props, {
    TabIndicatorProps: {
      children: /*#__PURE__*/_react["default"].createElement("div", null)
    }
  }));
});
var FilterTab = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      textTransform: 'none',
      color: theme.palette.darkGrey.light,
      fontSize: theme.typography.body1.fontSize,
      '&$selected': {
        fontWeight: 600,
        color: theme.palette.primary.light
      }
    },
    selected: {}
  };
})(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_Tab["default"], _extends({}, props, {
    disableRipple: true
  }));
});
var NavigationTabs = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      backgroundColor: theme.palette.lightGrey.main,
      borderRadius: '10px 10px 0 0'
    },
    indicator: {
      height: '100%',
      backgroundColor: 'white',
      zIndex: 0,
      borderRadius: '10px 10px 0 0'
    }
  };
})(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_Tabs["default"], _extends({}, props, {
    TabIndicatorProps: {
      children: /*#__PURE__*/_react["default"].createElement("div", null)
    }
  }));
});
var NavigationTab = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      zIndex: 1,
      textTransform: 'none',
      color: theme.palette.darkGrey.light,
      fontSize: theme.typography.body1.fontSize,
      '&$selected': {
        fontWeight: 600,
        color: theme.palette.primary.light
      }
    },
    selected: {}
  };
})(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_Tab["default"], props);
});
var Tabs = function Tabs(_ref2) {
  var items = _ref2.items,
    activeItem = _ref2.activeItem,
    variant = _ref2.variant,
    tabProps = _ref2.tabProps,
    tabsprops = _objectWithoutProperties(_ref2, _excluded);
  var theme = (0, _styles.useTheme)();
  var mobile = (0, _useMediaQuery["default"])(theme.breakpoints.down('sm'));
  var handleChange = function handleChange(event, clickedIndex) {
    return items[clickedIndex].onClick(event);
  };
  var TabsComponent = variant === 'navigation' ? NavigationTabs : FilterTabs;
  var TabComponent = variant === 'navigation' ? NavigationTab : FilterTab;
  return /*#__PURE__*/_react["default"].createElement(TabsComponent, _extends({
    variant: mobile ? 'fullWidth' : 'standard',
    value: activeItem,
    onChange: handleChange
  }, tabsprops), items.map(function (_ref3) {
    var name = _ref3.name,
      badge = _ref3.badge;
    return /*#__PURE__*/_react["default"].createElement(TabComponent, _extends({
      wrapped: true,
      disableRipple: true,
      label: /*#__PURE__*/_react["default"].createElement(Label, {
        name: name,
        badge: badge
      }),
      key: name
    }, tabProps));
  }));
};
Tabs.propTypes = {
  variant: _propTypes["default"].oneOf(['filter', 'navigation']).isRequired,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    badge: _propTypes["default"].number
  })).isRequired,
  tabProps: _propTypes["default"].shape({
    className: _propTypes["default"].string
  }),
  activeItem: _propTypes["default"].number
};
Tabs.defaultProps = {
  activeItem: 0,
  tabProps: {}
};
var _default = exports["default"] = Tabs;